import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelClassificationDictionaryInfo', request)
}

export {get}
